import React from 'react';

const InfoIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.0026 14.6666C11.6845 14.6666 14.6693 11.6818 14.6693 7.99992C14.6693 4.31802 11.6845 1.33325 8.0026 1.33325C4.32071 1.33325 1.33594 4.31802 1.33594 7.99992C1.33594 11.6818 4.32071 14.6666 8.0026 14.6666Z'
        stroke='#33ADFF'
        strokeWidth='1.33333'
      />
      <path
        d='M8 4.6665H8.00667'
        stroke='#33ADFF'
        strokeWidth='1.33333'
        strokeLinecap='round'
      />
      <path
        d='M6.67188 7.33325H8.00521V10.6666M6.67188 10.6666H9.33854'
        stroke='#33ADFF'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default InfoIcon;
